<template>
  <div>
    <div
      ref="public-searchForm"
      class="public-searchForm work-search search-nowarp"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        labelWidth="80px"
        @keyup.enter.native="search"
      >
        <el-form-item
          prop="id"
          label="组件id"
        >
          <el-input
            v-model.trim="searchForm.id"
            clearable
            placeholder="请输入组件id"
          />
        </el-form-item>
        <el-form-item
          prop="name"
          label="组件名称"
        >
          <el-input
            v-model.trim="searchForm.name"
            clearable
            placeholder="请输入组件名称"
          />
        </el-form-item>
        <el-form-item
          prop="assemblyType"
          label="组件类型"
        >
          <el-select
            v-model.trim="searchForm.assemblyType"
            clearable
            placeholder="请选择组件类型"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <div class="search-handler">
          <el-button
            icon="el-icon-refresh"
            @click="reset"
          >
            重置
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading.search"
            @click="search"
          >
            查询
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="public-table">
      <div class="public-table-top">
        <div class="table-title">
          自定义组件列表
        </div>
        <div class="public-table-top-btn">
          <el-button
            type="primary"
            size="mini"
            @click="publishAll"
          >
            全部部署
          </el-button>
          <el-button
            type="primary"
            size="mini"
            @click="add"
          >
            新增
          </el-button>
        </div>
      </div>
      <el-table
        v-if="showTable"
        ref="tableData"
        :height="tableHeight"
        :data="tableData"
        border
      >
        <el-table-column
          label="组件id"
          minWidth="200"
        >
          <div slot-scope="scope">
            <a @click="open(scope.row)">{{ scope.row.id }}</a>
          </div>
        </el-table-column>
        <el-table-column
          v-for="item in tableCol"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :minWidth="item.minWidth"
        />
        <el-table-column
          label="操作"
          width="260"
          fixed="right"
        >
          <div
            slot-scope="scope"
            class="public-form-table-item-operate"
          >
            <a @click="edit(scope.row)">修改</a>
            <a @click="del(scope.row)">删除</a>
            <a @click="copy(scope.row)">复制</a>
            <a @click="open(scope.row)">编辑组件</a>
            <a @click="publish(scope.row)">部署</a>
            <a @click="publishHistory(scope.row)">历史</a>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      ref="public-pagination"
      class="public-pagination"
    >
      <WPagination
        v-model="page"
        @change="query"
      />
    </div>
    <AddPublic
      v-if="showAdd"
      :isEdit="isEdit"
      :isCopy="isCopy"
      :value="rowValue"
      @close="showAdd = false"
      @addSuccess="addSuccess"
    />
    <Publish
      v-if="showPublish"
      :value="publishRow"
      @close="showPublish = false"
    />
    <PublishAll
      v-if="showPublishAll"
      @close="showPublishAll = false"
    />
    <PublishHistory
      v-if="showHistory"
      :id="historyId"
      hideHandle
      @close="showHistory = false"
    />
  </div>
</template>
<script>
import AddPublic from './addPublic.vue'
import Publish from '@workflow/components/public/publicPublish.vue'
import PublishAll from './publishAll.vue'
import PublishHistory from '@workflow/components/public/publicUpdateHistory.vue'
import tableHeight from '@workflow/mixins/tableHeight.js'
export default {
  name: 'FormPublic',
  components: { AddPublic, Publish, PublishAll, PublishHistory },
  mixins: [tableHeight],
  data() {
    return {
      loading: {
        search: false
      },
      typeList: [
        { value: 'form', label: '表单组件' },
        { value: 'table', label: '表格组件' },
        { value: 'dialog', label: '弹框组件' }
      ],
      typeMap: {
        form: '表单组件',
        table: '表格组件',
        dialog: '弹框组件'
      },
      searchForm: {
        name: '',
        id: '',
        assemblyType: ''
      },
      selectParam: {},
      page: {},
      rowValue: {},
      tableData: [],
      tableCol: [
        { label: '组件名称', key: 'name', minWidth: 200 },
        { label: '组件分类', key: 'assemblyTypeName' },
        { label: '创建人', key: 'createByView' },
        { label: '创建时间', key: 'createTime', minWidth: 150 },
        { label: '修改人', key: 'updateByView' },
        { label: '修改时间', key: 'updateTime', minWidth: 150 },
        { label: '描述', key: 'description', minWidth: 200 }
      ],
      showAdd: false,
      isEdit: false,
      isCopy: false,
      showPublish: false,
      showPublishAll: false,
      publishRow: {},
      showHistory: false,
      historyId: ''
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    reset() {
      this.$refs.searchForm.resetFields()
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      delete this.selectParam.categoryName
      this.query()
    },
    query() {
      this.loading.search = true
      const { current, size } = this.page
      this.$api.formAssembly.get({
        pageParam: { current, size },
        selectParam: this.selectParam
      }).then(data => {
        data.records.forEach(item => {
          item.assemblyTypeName = this.typeMap[item.assemblyType]
        })
        this.tableData = data.records
        this.page.total = data.total
      }).finally(() => {
        this.loading.search = false
      })
    },
    add() {
      this.showAdd = true
      this.isEdit = false
      this.isCopy = false
    },
    addSuccess() {
      this.showAdd = false
      this.query()
    },
    edit(row) {
      this.rowValue = row
      this.showAdd = true
      this.isEdit = true
    },
    copy(row) {
      this.rowValue = row
      this.showAdd = true
      this.isEdit = false
      this.isCopy = true
    },
    del(row) {
      this.$confirm('确定删除此项？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$api.formAssembly.del({ id: row.id }).then(() => {
          this.$message.success('删除成功!')
          const { total, size, current } = this.page
          if (current !== 1 && total > size && size * (current - 1) + 1 !== total) {
            this.reset()
          } else {
            this.query()
          }
        })
      }).catch(() => { })
    },
    open(row) {
      window.open(`/#/form/editor?id=${row.id}&type=public`)
    },
    publishAll() {
      this.showPublishAll = true
    },
    publish(row) {
      this.publishRow = row
      this.showPublish = true
    },
    publishHistory(row) {
      this.historyId = row.id
      this.showHistory = true
    }
  }
}
</script>
